import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HelpCenterContextPayload } from '../help-center/help-center.types';

@Injectable({
  providedIn: 'root'
})
export class HelpCenterContextService {
  constructor(
    private router: Router,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  getContext(): HelpCenterContextPayload {
    const globalWindow: any = typeof window !== 'undefined' ? window : {};

    return {
      route: this.router.url || '',
      pageTitle: this.document?.title || '',
      language: this.translate.currentLang || this.translate.getDefaultLang() || 'de',
      timestamp: new Date().toISOString(),
      userAgent: globalWindow.navigator?.userAgent || '',
      viewport: `${globalWindow.innerWidth || 0}x${globalWindow.innerHeight || 0}`,
      appVersion: globalWindow.__env?.APP_VERSION || undefined,
      user: {
        id: undefined,
        email: undefined,
        name: undefined,
        companyId: undefined
      }
    };
  }
}
